import CustomLocationIcon from '../../components/icons/LocationIcon';
import PriceWidgetComponent from '../../components/price-widget/PriceWidget';
import { BodyLarge } from '../../components/Typography';
import { Box, styled } from '@mui/material';
import { HFlex, VFlex } from '../../components/FlexContainers';
import { palette } from '../../theme/palette';
import { PrimaryButton } from '../../components/Buttons';

export const Root = styled(HFlex)`
  align-items: center;
  justify-content: space-between;
  margin-top: 0px;
  flex-wrap: wrap;
  gap: 15px 25px;
  @media (max-width: 767px) {
    gap: 20px;
  }
`;

export const LeftBlock = styled(VFlex)`
  gap: 10px;
`;

export const PriceWidget = styled(PriceWidgetComponent)`
  margin-right: 15px;
  .pricing-container {
    gap: 5px 10px;
  }
  .price-cell {
    min-width: 135px;
  }
  @media (max-width: 767px) {
    .pricing-container {
      gap: 5px 15px;
    }
    .price-cell {
      min-width: 60px;
    }
    .price-cell-typography {
      font-size: 16px;
    }
  }
`;

export const SelectLocation = styled(Box)`
  width: fit-content;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  cursor: pointer;
  font-size: 16px;
  color: ${palette.custom.darkGrey};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 22px;
`;

export const LocationIcon = styled(CustomLocationIcon)`
  color: ${palette.primary.main};
`;

export const AddToCartButton = styled(PrimaryButton)`
  padding: 0 15px;
  @media (max-width: 767px) {
    height: 40px;
    width: 100%;
  }
`;

export const ContactUs = styled(BodyLarge)`
  margin-bottom: 0;
`;

export const ContactUsNumber = styled(`a`)`
  letter-spacing: 0.35px;
  color: ${palette.custom.darkGrey};
  margin-bottom: 4px;
  width: fit-content;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
`;
